'use client';
import { Logo } from '@web-libs/features/branding/logo/ui/logo';
import React, { CSSProperties, useState } from 'react';
import { getCssVar } from '@web-libs/features/colors/application/colors';
import { SidebarItem, useSidebarItems } from '@web-libs/features/navigation/sidebar-items';
import { withClick } from '@web-libs/ui/svgs/clickable/with-click';
import { withColor } from '@web-libs/ui/svgs/fill/with-color';
import MenuIcon from '@web-libs/ui/svgs/icons/MenuIcon';
import CloseIcon from '@web-libs/ui/svgs/icons/CloseIcon';
import { LanguageSelector } from '@web-libs/ui/ui-components/language-selector/language-selector';
import { useTageaRouter } from '@web-libs/core/routing/application/use-tagea-router.concern';

export const SideMenu = () => {

  const [overlayOpen, setOverlayOpen] = useState(false);

  const overlayStyles: CSSProperties = {
    position: 'fixed',
    top: 0,
    right: 0,
    width: '250px',
    height: '100vh',
    backgroundColor: getCssVar('light'),
    zIndex: 1000,
    paddingRight: 20,
    paddingLeft: 20,
    paddingTop: 48,
    paddingBottom: 48,
    transition: 'transform 0.3s ease-in-out',
    transform: overlayOpen ? 'translateX(0)' : 'translateX(100%)', // Slide effect
    boxShadow: '0 0 10px 0 rgba(0,0,0,0.1)'
  };

  const MenuButton = withClick(withColor(MenuIcon));
  const CloseButton = withClick(CloseIcon);

  const close = () => {
    setOverlayOpen(false);
  };

  const router = useTageaRouter();

  return (
    <>
      <MenuButton style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }} onClick={() => {
        setOverlayOpen(true);
      }} />
      <div style={overlayStyles}>
        <div style={{ display: 'flex', justifyContent: 'end', marginBottom: 32 }}>
          <CloseButton onClick={close} height={24} width={24} />
        </div>
        <LanguageSelector containerStyle={{ height: 'unset', marginBottom: 16 }} background={'lightShadier'} />
        <div style={{marginBottom: 8}}>
          <a style={{ color: getCssVar('textColor'), fontSize: 20, fontWeight: 'bold' }} href={router.getLink('impressum')}>Impressum</a>
        </div>
        <div>
          <a style={{ color: getCssVar('textColor'), fontSize: 20, fontWeight: 'bold'  }} href={router.getLink('datenschutz')}>Datenschutz</a>
        </div>
      </div>

    </>
  );
};

export const TabletTageaSidebar = () => {
  const sidebarItemDefinitions = useSidebarItems();

  const logo = (
    <div style={{ height: 50 }}>
      <Logo fitParent />
    </div>
  );

  const _style: CSSProperties = {
    position: 'fixed',
    top: 0,
    left: 0,
    display: 'flex',
    padding: '25px 25px',
    flexDirection: 'row',
    justifyContent: 'space-between',
    height: '100px',
    width: '100%',
    borderRadius: 0,
    zIndex: 10,
    backgroundColor: getCssVar('lightShadier')
  };

  const _sidebarItemsStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    gap: '10px'
  };

  return (
    <div>
      <div style={_style}>
        <div>
          <div style={{ marginRight: 16 }}>{logo}</div>
        </div>
        <div style={_sidebarItemsStyle}>
          {sidebarItemDefinitions.map((sidebarItemDefinition, index) => (
            <SidebarItem
              key={index}
              icon={sidebarItemDefinition.icon}
              iconSize={50}
              active={sidebarItemDefinition.active}
              navDestination={sidebarItemDefinition.navDestination}
              notification={sidebarItemDefinition.notification}
            />
          ))}
        </div>
        <SideMenu />
      </div>
    </div>
  );
};

